<template>
  <div class="modal fade" id="changePictureModal" tabindex="-1" role="dialog"
       aria-labelledby="changePictureModalLabel">
    <div id="modal_take_picture" class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="takePictureModalLabel">
            Changer de photo
          </h4>
          <button type="button" class="close" data-dismiss="modal"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pb-0">

          <div id="video-container" class="d-none">
            <video id="video" autoplay playsinline></video>
          </div>

          <div class="row">
            <clipper-fixed :grid="false" :round="false" class="my-clipper col-12" ref="clipper" :src="imgURL"
                           :handle-zoom-events="(scale)" :rotate="rotation">
              <div class="placeholder text-center" slot="placeholder">Aucune image</div>
            </clipper-fixed>

            <div class="col mt-5">
              <h6>Zoom <span class="float-right"><!--{{ scale ? scale : 0 }}--></span></h6>
              <clipper-range v-model="scale" :min="0.25" :max="5"></clipper-range>
            </div>
            <div class="col mt-5">
              <h6>Redresser <span class="float-right"><!--{{ rotation ? rotation : 0 }}--></span></h6>
              <clipper-range v-model="rotation" :min="0" :max="360"></clipper-range>
            </div>

            <div class="col-12 mt-5">
              <div class="d-flex justify-content-between flex-column flex-md-row align-items-center">
                <clipper-upload name="photo" ref="photo" v-model="imgURL"
                                class="mb-3 w-100 w-md-40 btn btn-sm btn-primary">
                  <i class="fas fa-file-upload"></i>&nbsp;Télécharger la photo
                </clipper-upload>
              </div>
            </div>

            <div class="col-12 mb-5">
              <button type="button" @click.prevent="getResult" class="btn btn-success w-100">
                <i class="fas fa-check"></i>&nbsp;Valider
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

export default {
  props: [
    'crop_ratio',
  ],

  data: function () {
    return {
      imgURL: '',
      resultURL: '',
      scale: 1,
      rotation: 0,
      customW: 1000,
      customH: 0,
    }
  },
  watch: {
    scale(val) {
      this.$refs.clipper.setWH$.next(+val);
    },
  },
  mounted: function () {
    let stemArea = $('.vuejs-clipper-fixed__stem-area');
    this.customH = (this.customW * this.crop_ratio);
    stemArea.attr('width', this.customW);
    stemArea.attr('height', this.customH);
  },
  methods: {

    getResult: function () {
      let canvas = this.$refs.clipper;

      canvas = canvas.clip({wPixel: this.customW});//call component's clip method

      //working jpeg if you change getValue('photo_cam') to accept jpg in identitylight.php in e-shop->back
      //this.resultURL = canvas.toDataURL("image/jpeg", 1);
      //working png if you change getValue('photo_cam') to accept png in identitylight.php in e-shop->back
      this.resultURL = canvas.toDataURL("image/png");

      // TODO - Passer dans un prop
      $('#photo_cam').val(this.resultURL);
      $("#member_photo").attr("src", this.resultURL);
      $("#preview_photo").attr("src", this.resultURL);
      this.$emit('imgURL', this.resultURL)

      $('html, body').animate({
        scrollTop: $("#changePictureBtn").offset().top - 75,
      }, 750);

      // Close clipper modal
      $("#changePictureModal").modal('hide');
    },
    handleZoom(scale) {
      this.scale = scale;
      return scale;
    },
  }
}

</script>